module.exports = __webpack_public_path__ + "static/doublo-caisse-americaine-0307ef4c33dea16b360f8ad15bcb7b75.gif";